import { render, staticRenderFns } from "./page-plans.vue?vue&type=template&id=4ba37332&scoped=true"
import script from "./page-plans.vue?vue&type=script&lang=js"
export * from "./page-plans.vue?vue&type=script&lang=js"
import style0 from "./page-plans.vue?vue&type=style&index=0&id=4ba37332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba37332",
  null
  
)

export default component.exports